<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="content-chapter" id="calibre_toc_4"><a class="calibre4" id="_idTOCAnchor-30"></a>Foreword<span class="calibre4"></span></p>
<div class="calibre2" id="calibre_pb_4"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// YourNextLevelLife_split_004.vue?536bfa32